import { michiganKickerSharedAssetPreloader } from '../shared/asset-preloader'

export enum MI_MULTIPLIER_CORNHOLE_ASSETS {
  BACKGROUND = 'tailgate.jpg',
  BAG = 'bag.png',
  BOARD = 'cornhole-full-w-numbers.png',
  BOARD_BLANK = 'cornhole-full-no-numbers.png',
  FLASH = 'flash.png',
  HOLE_MASK = 'MI_HOLE_MASK',
  NUMBER_SUFFIX = 'x.png',
}

export enum MI_MULTIPLIER_CORNHOLE_TEXTURES {
  ATLAS = 'MI_MULTIPLIER_CORNHOLE_ATLAS',
}

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/cornhole/`

  michiganKickerSharedAssetPreloader(scene)

  if (!scene.textures.getTextureKeys().includes(MI_MULTIPLIER_CORNHOLE_TEXTURES.ATLAS)) {
    scene.load.multiatlas(
      MI_MULTIPLIER_CORNHOLE_TEXTURES.ATLAS,
      `${prefix}atlas/multiplier-cornhole-images.json`,
      `${prefix}atlas/`,
    )
  }
}
